export function getRecentPaths(): string[] {
  try {
    return JSON.parse(localStorage.getItem("pw-cmd-recent") || "[]");
  } catch {
    return [];
  }
}

export function addRecentPath(path: string) {
  try {
    const paths = getRecentPaths().filter((p) => p !== path);
    paths.unshift(path);
    localStorage.setItem("pw-cmd-recent", JSON.stringify(paths.slice(0, 5)));
  } catch {
    /* */
  }
}

export const CATEGORY_ORDER = [
  "Recent",
  "Pages",
  "Create",
  "Settings",
  "Account",
] as const;
